import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import pick from 'lodash/pick';
import values from 'lodash/values';
import compact from 'lodash/compact';
import { TestCenterDTO } from 'shared/models';
import { AlertNotice } from 'shared/components';

const formatAddress = tc =>
  compact(values(pick(tc, ['address1', 'address2', 'city', 'stateCode', 'postalCode'])))
    .join(', ');

const TcInfo = ({ tc }) => {
  const { t } = useTranslation();
  const testCenter = new TestCenterDTO(tc);

  return (
    <section className="tc-info-section tc-dash-section">
      <h5 className="mb-4">{t('testCenter.testCenterInformationTitle')}</h5>
      <AlertNotice message={t('testCenter.addressInfoWarning')} />
      <h6 className="fw-bold">{t('common.labels.address')}</h6>
      <p>{formatAddress(testCenter)}</p>
      <h6 className="fw-bold">{t('dashboard.labels.type')}</h6>
      <p>{testCenter.tcType && testCenter.tcType.name}</p>
    </section>
  );
}

export default TcInfo;

TcInfo.propTypes = {
  tc: PropTypes.shape({
    tcType: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
};
